/* eslint camelcase: ["error", {allow: ["__webpack_lazy_fm_cache__", "__webpack_lazy_fm__"]}] */
/* eslint-env browser */
/* global System */

(function () {
	// Undefine: nothing to do
	// 1: loaded
	// array: list of callbacks sets to call
	globalThis.__webpack_lazy_fm_cache__ = globalThis.__webpack_lazy_fm_cache__ || {};
	const modulesCache = globalThis.__webpack_lazy_fm_cache__;

	function globalVarLoader(remoteEntry, remoteName) {
		const prom = new Promise((resolve, reject) => {
			if (modulesCache[remoteEntry] === 1) {
				resolve(globalThis[remoteName]);
				return;
			}

			if (Array.isArray(modulesCache[remoteEntry])) {
				modulesCache[remoteEntry].push([resolve, reject]);
				return;
			}

			const script = document.createElement('script');
			script.setAttribute('data-webpack', remoteName);
			script.charset = 'utf-8';
			script.timeout = 120;
			script.src = remoteEntry;

			script.onerror = error => {
				delete modulesCache[remoteEntry];
				modulesCache[remoteEntry].forEach(([, reject]) => {
					reject(error);
				});
			};

			script.onload = () => {
				modulesCache[remoteEntry].forEach(([resolve]) => {
					resolve(globalThis[remoteName]);
				});
				modulesCache[remoteEntry] = 1;
			};

			modulesCache[remoteEntry] = [];
			modulesCache[remoteEntry].push([resolve, reject]);

			document.body.appendChild(script);
		});
		return prom;
	}

	function systemJsLoader(name) {
		if (typeof globalThis.System === 'undefined') {
			throw new Error('SystemJS is not loaded in the application');
		}

		return System.import(name).catch(error => {
			if (error.message.includes('Unable to resolve bare specifier') && globalThis[name]) {
				throw new Error(
					`The module '${name}' can not be found in SystemJS, but there is a global that matches the same name ('${name}').\nMake sure that the module type in the webpack configuration of the consumer and producer are the same.`,
				);
			}
		});
	}

	globalThis.__webpack_lazy_fm__ = function (loaderFn) {
		let initiated = false;
		let _shareScope;
		let _initScope;

		const resolver = {
			get: function (module, getScope) {
				return (initiated ? Promise.resolve() : resolver.init())
					.then(() => loaderFn())
					.then(mod => mod.get(module, getScope));
			},
			init: function (shareScope, initScope) {
				if (!shareScope && !initScope) {
					return loaderFn()
						.then(mod => mod.init(_shareScope, _initScope))
						.then(result => {
							initiated = true;
							return result;
						});
				}

				_shareScope = shareScope;
				_initScope = initScope;
			},
		};
		return resolver;
	};

	globalThis.__webpack_lazy_fm__.systemjs = function (name) {
		return globalThis.__webpack_lazy_fm__(systemJsLoader.bind(undefined, name));
	};

	globalThis.__webpack_lazy_fm__.globalVar = function (remoteEntry, remoteName) {
		return globalThis.__webpack_lazy_fm__(globalVarLoader.bind(undefined, remoteEntry, remoteName));
	};
})();
